module.exports = __webpack_public_path__ + "static/media/image02.bdfb554b.png";